import useTikTokPostComposerStep from './useTikTokPostComposerStep';

export default useTikTokPostComposerStep;
